<div class="flex flex-col items-start reviews w-full">
    <span class="flex items-center gap-2 w-full">
        <div class="w-12 h-12 flex justify-center items-center">
            <p-avatar
                [label]="message().data.sender?.firstInitial + message().data.sender?.lastInitial"
                class="text-white bg-slate-500 text-lg" size="large" shape="circle"></p-avatar>
        </div>

        <div class="flex flex-col gap-1">
            <div class="mr-1">
                <span>{{message().data.sender?.displayName}}</span>

                <span class="items-center mr-1" >
                    {{ message().data.content?.primaryText }}
                </span>

                <a class="text-primary font-bold cursor-pointer"
                    [routerLink]="message().data.content?.primaryUrl | routerLinkSafeUrl" target="_blank" rel="noopener noreferrer">
                    @if(message().data.category === NotificationCategory.NarrativeReviews) {
                        Narrative
                    }
                    @else {
                        Incident
                    }

                    Review {{ message().data.content?.primaryUrl | urlSegment: 'reviews'}}
                </a>
            </div>

            @if(message().data.content?.secondaryText){
                <div class="flex justify-between my-1">
                    <a class="text-primary uppercase font-bold cursor-pointer"
                        [routerLink]="message().data.content?.secondaryUrl | routerLinkSafeUrl" target="_blank" rel="noopener noreferrer">
                        <i class="fa-solid fa-file-lines"></i>
                        {{ message().data.content?.secondaryText }}
                    </a>
                </div>
            }
        </div>
    </span>
</div>